/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'

import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { ComparisonMode } from 'enums'
import { AudienceTimelineComparisonWidget } from 'schemas/AudienceTimelineComparisonWidgetSchema'
import { TopicNotSelectedGuard } from '../../../../share/guards'
import ThemesMatrixedItemCountGuard from '../../../share/ComparisonMode/guards/ThemesMatrixedItemCountGuard'

const ComparisonModeWidgetSettingGuards: WidgetGuard = ({ widgetId, children }) => {
  const { comparisonMode } = useDashboardWidgetSetting<AudienceTimelineComparisonWidget>(widgetId)

  return (
    <TopicNotSelectedGuard widgetId={widgetId}>
      <>
        {comparisonMode === ComparisonMode.THEMES && (
          <ThemesMatrixedItemCountGuard widgetId={widgetId}>
            {children}
          </ThemesMatrixedItemCountGuard>
        )}
      </>
    </TopicNotSelectedGuard>
  )
}

export default ComparisonModeWidgetSettingGuards
